import * as React from "react";
import BannerHybrid from "./BannerHybrid";
import type { TypeBannerProps } from "./BannerTypes";

/**
 * Banner component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
const Banner = (props: TypeBannerProps) => <BannerHybrid {...props} />;

export default Banner;
